<template>
<div id="adjuntos_explorer" :key="'explorer' + regenera">

    <v-layout align-center justify-center>
        <v-flex xs4 style="margin-top:30px">
            <v-card class="mx-auto" height="550px" max-width="400">
               
                <v-card-text>
                    
                    <div class="tree" v-if="items.length > 0">
                        <div class="contenido">
                            <v-treeview v-model="tree" :items="items" active-class="secondary lighten-4 indigo--text" :active.sync="active" activatable @update:active="preview" returnObject dense open-all :key="key">
                                <template v-slot:prepend="{ item, open }">
                                    <v-icon v-if="item.file == 'folder' ">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
                                    <v-icon v-else>{{ files[item.file.toUpperCase()] }}</v-icon>
                                </template>
                            </v-treeview>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs8 style="margin-top:-30px">
            <h2>{{label}}</h2>
            <v-card class="mx-auto"  height="550px" v-if="active.length > 0">
                <h5><v-icon small >search</v-icon>Vista Previa</h5>
            
                <v-card-text>
                    <table class="table table-condensed table-bordered">
                        <tbody>
                            <tr>
                                <td>
                                    <span id="lab_title_file">Archivo</span>:
                                </td>
                                <td>
                                    <strong>
                                        <span id="lab_file">{{active[0].name}}</span>
                                    </strong>
                                </td>

                                <td>Tamaño:</td>

                                <td>
                                    <strong>
                                        <span id="lab_size">{{active[0].size}} MB</span>
                                    </strong>
                                </td>

                                <td>
                                       <v-dialog v-model="confirm" persistent max-width="490">
                                                        <v-card>
                                                            <v-card-title class="headline">Confirme la operación!</v-card-title>
                                                            <v-card-text>Realmente desea eliminar el archivo adjunto del expediente?</v-card-text>
                                                            <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="red darken-1" text @click="confirm = false">No</v-btn>
                                                            <v-btn color="green darken-1" text @click="eliminar(active[0].dir )">Si</v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                        </v-dialog>
                                                         <v-btn  v-if="borrable" @click="confirm = true" rounded small color="red"  title="Eliminar" v-tippy>
                                                            <v-icon>mdi-trash-can</v-icon>
                                                        </v-btn>
                                    <v-btn rounded color="secondary" small @click="download" title="Descargar" v-tippy>
                                        <v-icon>mdi-download</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                             <tr >
                                <td>
                                    <span id="lab_title_file">Usuario</span>:
                                </td>
                                <td>
                                    <strong>
                                        <span id="lab_file">{{active[0].usuario}}</span>
                                    </strong>
                                </td>

                                <td>Origen:</td>

                                <td>
                                    <strong>
                                        <span id="lab_size">{{active[0].fuente}}</span>
                                    </strong>
                                </td>

                                <td>
                                    <strong>
                                        <span id="lab_size">{{active[0].fecha}}</span>
                                    </strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br/>
                    <div v-if="active[0].file.toUpperCase()=='XML' " class="global">
                        <div class="contenido">
                            <pre class="preformat">{{xmlContent}} </pre>
                        </div>
                    </div>
                        <div  id="app" v-if="active[0].file.toUpperCase()=='PDF'">
                            <PDFViewer v-bind="{url}" @document-errored="onDocumentErrored"></PDFViewer>
                        </div>
                    <div v-if="active[0].file.toUpperCase()=='PNG'" class="global">
                        <div class="contenido">
                            <v-img :src="url" aspect-ratio="2"></v-img>
                        </div>
                    </div>
                    <v-alert border="top" colored-border type="info" elevation="2" v-if="active[0].file.toUpperCase() !='PDF' && active[0].file.toUpperCase() !='XML' && active[0].file !='PNG' && active[0].file.toUpperCase() !='TXT' && active[0].file !=''">Vista previa no disponible.</v-alert>

                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>

</div>
</template>

<script>
import {
    request
} from "http";
import {
    mapState
} from "vuex";
import axios from "axios";
import PDFViewer from "@/components/pdf/PDFViewer.vue";
import beautify from "xml-beautifier";

export default {
    props: {
        adjuntos_array: {
            type: Array,
        },
        referencia: {
            type: String
        },
    },
    components: {
        PDFViewer
    },
    created() {
    },
    computed: {
        regenera() {
            this.items = [];
            this.llenar();
            return this.referencia;
        },

    },
    methods: {
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
     
           eliminar(key) {
             this.$root.$dialogLoader.show('Espere un momento por favor..');
             this.active = [];
            var datos = {
                key: key
            }
            axios.post(this.$hostname + 'traficos/delete_adjunto/', datos)
                .then((response) => {
                    console.log(response);
                    if (typeof response.data !== 'undefined') {
                        this.confirm = false;
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa!",
                            text: "El archivo se eliminó correctamente",
                            footer: '',
                        });
                        this.$parent.$parent.$parent.$parent.$parent.$parent.$refs.updatedetalles.$emit("click");
                        this.items = [];
                        this.llenar();
                        
                    }
                })
                .catch((error) => {
                    this.confirm = false;
                    var mensaje = "Ocurrió un error al eliminar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.confirm = false;
                    this.$root.$dialogLoader.hide();
                });

        }, 
        preview() {
                this.borrable = true;
              if (!this.active.length || this.active[0].file == "zip" || this.active[0].file == "folder") {
                 this.borrable = false;
                return undefined;
            }
            if (this.active[0].file.toUpperCase() == "PDF" || this.active[0].file.toUpperCase() == "XML" || this.active[0].file.toUpperCase() == "PNG") {
                this.$root.$dialogLoader.show('Espere un momento por favor..');
                this.xmlError = false;
                var datos = {
                    id: this.active[0].dir,
                    bucket: "production.econnect.ds"
                }
                var result = "";
                axios.post(this.$hostname + 's3/download/', datos)
                    .then((response) => {
                        if (typeof response.data !== 'undefined') {
                            let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                                    type: response.headers["content-type"]
                                }),
                                url = window.URL.createObjectURL(blob);
                            if (this.active[0].file.toUpperCase() == "PDF") {
                                this.url = url;
                            }
                            if (this.active[0].file.toUpperCase() == "XML") {
                                this.xmlContent = atob(response.data)
                            }
                            if (this.active[0].file.toUpperCase() == "PNG") {
                                this.url = atob(response.data)
                            }
                            this.borrable = this.active[0].file != "zip" && this.active[0].file != "folder";
                        } else {
                            this.borrable = false;
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "No se encontró el archivo a descargar en S3",
                                footer: '',
                            });
                        }
                        this.$root.$dialogLoader.hide();
                    })
                    .catch((error) => {
                        console.log(error);
                        this.borrable = false;
                        this.$root.$dialogLoader.hide();
                    });
            }

        },
        download() {
            if (this.active[0].file == "zip" || this.active[0].file == "folder") {
                this.generateZip(this.active[0].dir);
            } else {
                this.downloadFile(this.active[0].dir);
            }

        },
        urlUpdated(url) {
            this.documentError = undefined;
            this.url = url;
        },

        onDocumentErrored(e) {
            this.documentError = e.text;
        },

        llenar: function () {
            var self = this;
            if (self.adjuntos_array.length > 0) {
                var res = self.referencia.split("-");
                self.rfc = res[0];
                self.num = res[1];
                var i = 1;
                var adjuntos = [];
                var size_adjuntos = 0;
                var carpetas_adjuntos = [];
                self.adjuntos_array.forEach(function (j) {
                    var sub = j.filename.split("_");
                    if (sub.length > 0) {
                        if (carpetas_adjuntos.includes(sub[0]) == false) {
                            carpetas_adjuntos.push(sub[0]);
                        }
                    }
                });
                

                var l = 0;
                var size = 0;
                carpetas_adjuntos.forEach(function (y) {
                    var child_adjuntos = [];
                    var child_adjuntos_size = 0;
                    var w = 1;

                    self.adjuntos_array.forEach(function (z) {
                        size = 0;
                        if (z.size > 0) {
                            size = parseFloat((((z.size / 1024)) / 1024)).toFixed(3);
                        }
                        var sub = z.filename.split("_");
                        if (sub.length > 0) {
                            if (sub[0] == y) {
                                sub = sub[0] + "/";
                                child_adjuntos.push({
                                    id: sub + z.filename + "." + z.ext,
                                    name: z.filename + "." + z.ext,
                                    dir: self.rfc + "/traficos/" + self.num + "/adjuntos/" + sub + z.filename + "." + z.ext,
                                    file: z.ext,
                                    size: size,
                                    usuario: z.nombre_usuario,
                                    fecha: z.fecha.substring(0, 10),
                                    fuente: z.fuente
                                });
                                child_adjuntos_size = child_adjuntos_size + parseFloat(z.size);
                            }
                        }
                        w = w + 1;

                    });
                    size = 0;
                    if (child_adjuntos_size > 0) {
                        size = parseFloat((((child_adjuntos_size / 1024)) / 1024)).toFixed(3);
                    }
                    adjuntos.push({
                        id: y,
                        name: y,
                        dir: self.rfc + "/traficos/" + self.num + "/adjuntos/" + y,
                        file: "folder",
                        size: size,
                        children: child_adjuntos,
                        usuario: "",
                        fecha: "",
                        fuente: ""
                                });
                   

                    size_adjuntos = size_adjuntos + parseFloat(child_adjuntos_size);

                    l = l + 1;
                });
                 if (size_adjuntos > 0) {
                        size = parseFloat((((size_adjuntos / 1024)) / 1024)).toFixed(3);
                    }
                if (adjuntos.length > 0) {
                    self.items.push({
                        id: "Adjuntos",
                        name: "Adjuntos",
                        dir: self.rfc + "/traficos/" + self.num + "/adjuntos",
                        file: "folder",
                        size: size_adjuntos.toFixed(2),
                        children: adjuntos,
                        usuario: "",
                        fecha: "",
                        fuente: ""
                    });
                    self.label="";

                }

            } else {
                self.label="No cuenta con archivos adjuntos.."
            }

        },
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('Espere un momento por favor..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download/', datos)
                .then((response) => {
                    if (typeof response.data !== 'undefined') {

                        let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                                type: response.headers["content-type"]
                            }),
                            url = window.URL.createObjectURL(blob);

                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";

                        a.href = url;
                        var arreglo = key.split("/")
                        a.download = arreglo[arreglo.length - 1];
                        a.click();

                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar en S3",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        generateZip: function (key) {
            this.$root.$dialogLoader.show('Espere un momento por favor..');
            var datos = {
                key: key,
                usuario: this.$local_storage.get("id_usuario"),
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_zip/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        this.$swal({
                            type: "info",
                            title: "Generado...",
                            text: "En breve recibirás una notificación para descargar el ZIP",
                            footer: '',
                        });
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar en S3",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
    },
    data: () => ({
        fab: false,
        xmlError: false,
        xmlContent: "",
        url: "",
        file: "",
        search: null,
        key: 1,
        active: [],
        sel: null,
        URL: "",
        rfc: "",
        num: "",
        confirm:false,
        borrable: false,
        label: "",
        files: {
            PDF: "mdi-file-pdf",
            PNG: "mdi-file-image",
            JPG: "mdi-file-image-outline",
            TXT: "mdi-file-document-outline",
            XLS: "mdi-file-excel",
            XLSX: "mdi-file-excel",
            DOCX: "mdi-file-word",
            DOC: "mdi-file-word",
            XML: "mdi-file-code-outline",
            zip: "mdi-folder-zip"
        },
        tree: [],
        items: [],
    })
};
</script>

<style scoped>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: white;
    margin-top: 0px;
}
td{
    height: 35px !important;
    font-size: small ;
}
table{
    margin-top:-20px;
}
.error {
    border: 1px solid red;
    background: pink;
    color: red;
    padding: 0.5em 3em;
    display: inline;
}

.box-shadow {
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
}

.overflow-hidden {
    overflow: hidden;
}

@media print {
    body {
        background-color: transparent;
    }

    #app {
        margin: 0;
        padding: 0;
    }
}

.global {
    margin-left: 10px;
    margin-top: 20px;
    height: 382px;
    width: 100%;
    border: 1px solid #ddd;
    background: #f1f1f1;
    overflow: scroll;
}

.tree {
    margin-left: 0px;
    margin-top: -20px;
    height: 450px;
    width: 100%;
    border: 1px solid #ddd;
    background: #f1f1f1;
    overflow-y: scroll;
}

.contenido {
    padding: 5px;
    font-size: small;
    overflow: auto;
}
.preformat{
    word-break: break-all; 
    word-wrap: break-word;
    white-space: pre-wrap
}
.v-card__subtitle,
.v-card__text {
    line-height: 0.95rem !important;
}

.v-treeview--dense .v-treeview-node__root {
    min-height: 20px !important;
}


</style>
